import axios from "axios";
import {BASE_URL} from "./url_config.js";
import {log} from "@/composables/useLog"
import { useStore } from 'vuex'
let distributor_id=1


const loginWithToken= async (token)=>{
    log("welcome in loginWithToken("+token+")")
    const store = useStore()
    log(1.1)
    try{
        log(1.2)
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        const url=BASE_URL+'/home/loginWithToken'
        log(url)
        log(headers)
        log(1.3)
        const result= await axios.get(url,  {headers: headers})
        log(1.4)
        log("result.data din axios in loginWithToken")
        // log(result)
        log(result.data)
        log(1.5)
        if(result.data.error==true){
            log(1.6)
            log("am gasit la intoarcere axios in loginWithToken errror==true!, iesim")
            return result.data
        }
        else{
            log(1.7)
            if(result.data.user.payment_method_token) {
                log(1.8)
                log("am gasit in loginWithToken payment_method_token si il scriem in store")
                store.commit('setActivePaymentToken', result.data.user.payment_method_token)
            }else {
                log(1.9)
                log("Nu am gasit in loginWithToken payment_method_token")
            }
            log(1.11)
            store.commit('setToken',{token: result.data.token})
            store.commit('setUser', {user: result.data.user})
            store.commit('setLoggedIn', result.data.loggedIn)
            log(1.111)
            setTimeout(()=>{
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                log(params)
                log("distributor_id="+distributor_id)



            }, 1000)
            return result.data
        }
    }catch{
        log("1.1.1")
        log("alerta de eroare la autentificare get getUserInfo")
        return {error:true,message:"invalid data"}
    }
}







const useLoginWithToken=()=>{
    return {loginWithToken, distributor_id}
}

export  default  useLoginWithToken
